/*
 * Kairos hız adımı 10 — 8 Ekim 2026.
 * Hedef: assets/product-modal.js (dosyanın tamamını değiştirin).
 * Kaynak: 08OCT2026-1055pm tema dışa aktarımı.
 * Yalnız video/3B penceresi: ana ürün galerisi ve PhotoSwipe değiştirilmez.
 * Kaydırıcı ilk açılışta kurulur; kapalı pencere sayfa tıklamalarını işlemez.
 */
class ProductModal extends ModalDialog {
  constructor() {
    super();
    this.sliderInstance = null;
    this.kairosDocumentClick = event => {
      if (!this.hasAttribute('open')) return;
      if (this.contains(event.target) || this.openedBy?.contains(event.target)) return;
      this.hide();
    };
  }

  initializeSlider() {
    if (this.sliderInstance && !this.sliderInstance.destroyed) return true;
    const element = this.querySelector('[data-modal-slider]');
    if (!element || !element.querySelector('[data-media-id]') ||
        typeof Swiper !== 'function') return false;

    this.sliderInstance = new Swiper(element, {
      slidesPerView: 1,
      navigation: {
        prevEl: this.querySelector('.swiper-button--prev'),
        nextEl: this.querySelector('.swiper-button--next')
      },
      on: {
        slideChangeTransitionEnd: swiper => {
          this.playActiveSlideVideo(swiper);
        }
      }
    });
    return true;
  }

  show(opener) {
    if (!opener || !this.querySelector('[data-modal-slider] [data-media-id]')) return;
    this.openedBy = opener;
    this.setAttribute('open', '');

    // Ölçüm yapılabilmesi için pencere görünür olduktan sonra kurulur.
    if (!this.initializeSlider()) {
      this.removeAttribute('open');
      return;
    }

    trapFocus(this, this.dialogHolder);
    window.pauseAllMedia();

    if (opener.hasAttribute('data-model-opener')) {
      this.showActiveMedia(opener.dataset.mediaId);
      return;
    }

    this.showActiveMedia();
  }

  connectedCallback() {
    document.addEventListener('click', this.kairosDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.kairosDocumentClick);
    if (this.hasAttribute('open')) this.hide();
    if (this.sliderInstance && !this.sliderInstance.destroyed) {
      this.sliderInstance.destroy(true, true);
    }
    this.sliderInstance = null;
  }

  showActiveMedia(activeMedia = 'videos') {
    if (activeMedia !== 'videos') {
      const activeMediaId = this.openedBy.getAttribute('data-media-id');
      const activeMedia = this.querySelector(
        `[data-media-id="${activeMediaId}"]`
      );
      if (!activeMedia) return;
      activeMedia.loadContent?.();
      activeMedia.parentElement.classList.add('swiper-slide');
      activeMedia.parentElement.classList.remove('hidden');
      this.querySelectorAll('[data-media-id]').forEach(media => {
        if (media === activeMedia) return;
        media.parentElement.classList.remove('swiper-slide');
        media.parentElement.classList.add('hidden');
      });
      this.sliderInstance.update();
      return;
    }

    const modalMedia = this.querySelectorAll('[data-media-id]');
    modalMedia.forEach(media => {
      if (media.tagName.toLowerCase() === 'product-model') {
        media.parentElement.classList.remove('swiper-slide');
        media.parentElement.classList.add('hidden');
        return;
      }
      media.parentElement.classList.add('swiper-slide');
      media.parentElement.classList.remove('hidden');
    });

    this.querySelector(
      '[data-media-id]:not(.hidden [data-media-id])'
    )?.loadContent?.();
  }

  hide() {
    // ModalDialog.hide() odak ve medya durumunu değiştirir.
    // Kapalı pencere, menü/renk/sepet gibi bağımsız işlemlere dokunmaz.
    if (!this.hasAttribute('open')) return;
    super.hide();
    pauseAllMedia();
    const activeModel = this.querySelector(
      '.swiper-slide-active product-model'
    );
    if (!activeModel) return;
    activeModel.removeAttribute('loaded');
    activeModel.querySelector('.shopify-model-viewer-ui')?.remove();
  }

  playActiveSlideVideo(swiper) {
    if (!this.hasAttribute('open')) return;
    pauseAllMedia();
    const activeSlide = Array.from(swiper.slides || []).find(slide =>
      slide.classList.contains('swiper-slide-active')
    );
    activeSlide?.querySelector('deferred-media')?.loadContent?.();
  }
}

customElements.define('product-modal', ProductModal);
